import axios from '@/utils/axios';

// Types

export class PayloadChangeEmailRequest {
	newEmail!: string;
}

// API

export default {
	async getAll(name: string): Promise<any[]> {
		return (await axios().get(`/users/?name=${name}`)).data;
	},

	async getCurrent(): Promise<any> {
		return (await axios().get('/users/current/')).data;
	},

	async getChildren(): Promise<any[]> {
		return (await axios().get('/users/current/children/')).data;
	},

	async getChildrenForBooking(): Promise<any[]> {
		return (await axios().get('/users/current/children?filter=BOOKING')).data;
	},

	async changeEmail(payload: PayloadChangeEmailRequest) {
		return (await axios().patch('/users/current/email/', payload)).data;
	},

	async getUsersForBooking(): Promise<any[]> {
		return (await axios().get('/users/current/bookable?filter=BOOKING')).data;
	},

};
